import React, { Component, PropTypes } from 'react';
import deepEqual from 'deep-equal';
import debounce from 'lodash/debounce';
import reduce from 'lodash/reduce';
import qs from 'qs';

import pick from 'lodash/pick';

// import { genericRoute } from '../../routes';
import Select from '../../form/select/select';
import MultiSelect from '../../form/select/multiselect';
import { locales as dateLocales } from '../../../utils/date';

import {
	STATE_ALL_ON,
	STATE_ALL_OFF,
	STATE_UNDETERMINED,
} from '../../../constants/states';

// import css from './header.scss';

export default class HeaderFilter extends Component {
	static propTypes = {
		categories: PropTypes.object.isRequired,
		timelineActions: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		isFetching: PropTypes.bool,
	};

	static defaultProps = {
		categories: {},
		isFetching: false,
	};

	constructor(props) {
		super(props);
		const state = {
			filter: {
				filter: {},
				date: '',
			},
			show: false,
		};

		this.toggleShow = this.toggleShow.bind(this);
		const query = qs.parse(location.search.slice(1));
		if (
			typeof query.filterDate !== 'undefined'
			&& typeof query.filterAwards !== 'undefined'
			&& typeof query.filterCaseTypes !== 'undefined'
			&& typeof query.filterEditorials !== 'undefined'
		) {
			const date = query.filterDate || '';
			const awards = this.filterDataParse(query.filterAwards) || {};
			const caseTypes = this.filterDataParse(query.filterCaseTypes) || {};
			const editorials = this.filterDataParse(query.filterEditorials) || {};

			state.filter.filter = {
				awards,
				caseTypes,
				editorials,
			};

			state.filter.date = date;

			setTimeout(() => {
				this.fetchTimeline({ filter: state.filter });
			}, 0);
		}



		this.state = state;
	}

	componentWillMount() {
		this.props.browser.scroll.register(this.toggleShow);
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.toggleShow);
	}

	componentWillUpdate(nProps, nState) {
		if (
			(() => {
				// check if filter has changed by looping through it - or assume it has i size has changed
				if (
					this.state.filter.length &&
					nState.filter.length &&
					this.state.filter.filter.length !== nState.filter.filter.length
				) {
					return true;
				}

				let keys = Object.keys(nState.filter.filter);
				for (let i = 0; i < keys.length; i++) {
					let prev = this.state.filter.filter[keys[i]];
					let next = nState.filter.filter[keys[i]];

					// if (keys[i] == 'awards') {
					// 	console.log(keys[i]);
					// 	console.log(prev);
					// 	console.log(next);
					// }

					if (!deepEqual(prev, next)) {
						return true;
					}
				}

				return false;
			})() || // or if date has changed
			this.state.filter.date !== nState.filter.date
		) {

			if (typeof this.props.timelineActions.setFilter === 'function') {
				function getCurrentStatus(filter) {
					let keys = Object.keys(filter);
					let prevVal;
					for (let i = 0; i < keys.length; i++) {
						let newKey = Object.keys(filter[keys[i]]);
						for (let k = 0; k < newKey.length; k++) {
							if (prevVal !== undefined && prevVal !== filter[keys[i]][newKey[k]]) {
								return STATE_UNDETERMINED;
							}

							prevVal = filter[keys[i]][newKey[k]];
						}
					}

					return prevVal ? STATE_ALL_ON : STATE_ALL_OFF;
				}

				this.props.timelineActions.setFilter(getCurrentStatus(nState.filter.filter));
			}

			let modFilter = ((filter) => {
				const newFilter = { ...filter };
				const keys = Object.keys(newFilter);

				let allFalse = true;
				for (let i = 0; i < Math.min(keys.length, 2); i++) {
					let iKeys = Object.keys(newFilter[keys[i]]);
					for (let k = 0; k < iKeys.length; k++) {
						if (newFilter[keys[i]][iKeys[k]]) {
							allFalse = false;
							break;
						}
					}
				}

				for (let i = 0; i < keys.length; i++) {
					let iKeys = Object.keys(newFilter[keys[i]]);
					if (allFalse) {
						for (let k = 0; k < iKeys.length; k++) {
							newFilter[keys[i]][iKeys[k]] = true;
						}
					}
				}

				return newFilter;

			})(nState.filter.filter);

			let newFilter = {
				...nState.filter,
				filter: modFilter,
			}

			// then fetch timeline
			this.fetchTimeline({
				filter: JSON.stringify(newFilter),
			});
		}
	}

	render() {
		let date = new Date();
		let className = 'span4 span6-tablet span14-mobile header-main__filter';

		if (this.state.show || this.filtersActive()) {
			className += ' header-main__filter--show';
		}

		return (
			<div className={className}>
				<MultiSelect
					ref='filters'
					placeholder='Filters'
					className='nav-filter-select'
					dropdownClass='span6-plus span10-tablet-plus span14-mobile-plus'
					options={this.getCategories()}
					defaultState={true}
					allowToggleAll={true}
					showSpinner={this.props.isFetching}
					defaultFilterState={this.state.filter.filter}
					onChange={(value) => this.updateFilterValue(value, 'filter')}
				/>
				<Select
					ref='date'
					placeholder='Date'
					className='nav-date-select hide-mobile'
					options={[
						{
							label: 'Latest',
							value: `${date.getFullYear()}-${date.getMonth() + 1}`,
						},
					].concat(this.getMonthArray())}
					value={this.state.filter.date}
					onChange={(value) => this.updateFilterValue(value, 'date')}
				/>
			</div>
		);
	}

	filtersActive() {
		if (this.refs.filters && this.refs.date) {
			return (this.refs.filters.state.isActive || this.refs.date.state.isActive);
		}

		return false;
	}

	toggleShow(e) {
		let show = (e.scrollY > 10);

		if (show !== this.state.show) {
			this.setState({
				...this.state,
				show: show,
			});
		}
	}

	updateFilterValue(value, index) {
		if (value && index) {
			let filter = { ...this.state.filter };
			filter[index] = value;

			const { date, filter: { awards, caseTypes, editorials } } = filter;

			const filterDate = date;
			const filterAwards = this.filterDataStringify(awards);
			const filterCaseTypes = this.filterDataStringify(caseTypes);
			const filterEditorials = this.filterDataStringify(editorials);
			const filterString = qs.stringify({
				filterDate,
				filterAwards,
				filterCaseTypes,
				filterEditorials,
			});

			history.replaceState({}, '', `${location.pathname}?${filterString}`);

			this.setState({ filter });
		}
	}

	getJsonFromUrl() {
		const query = location.search.substr(1);
		const result = {};
		query.split('&').forEach((part) => {
			const item = part.split('=');
			result[item[0]] = decodeURIComponent(item[1]);
		});

		return result;
	}

	filterDataStringify(data) {
		return reduce(data, (result, value, key) => {
			let computedValue = value;
			if (typeof(computedValue) === 'boolean') {
				computedValue = computedValue ? '1' : '0';
			}
			return `${result}${result ? '-' : ''}${key}.${computedValue}`;
		}, '');
	}

	filterDataParse(dataStr) {
		const dataArray = dataStr.split('-').map((keyValueStr) => {
			const keyValue = keyValueStr.split('.');
			return { key: keyValue[0], value: keyValue[1] };
		});

		const data = {};
		for (let index = 0; index < dataArray.length; index++) {
			const item = dataArray[index];
			let value = item.value;
			if (value === '0' || value === '1') {
				value = !!parseInt(value, 10);
			}

			data[item.key] = value;
		}

		return data;
	}



	getMonthArray() {
		let nowDate = new Date();
		let beginDate = new Date('2000-06-01');
		let dates = [];
		let addHeader = null;

		function daysInMonth(month, year) {
			return new Date(year, month, 0).getDate();
		}

		nowDate.setMonth(nowDate.getMonth() - 1); // set to previous month

		while (beginDate.getTime() < nowDate.getTime()) {
			if (addHeader !== nowDate.getFullYear()) {
				dates.push({
					label: nowDate.getFullYear(),
					value: 0,
					disabled: true,
				});
			}

			dates.push({
				label: `${dateLocales.en.monthNames[nowDate.getMonth()]} ${nowDate.getFullYear()}`,
				value: `${nowDate.getFullYear()}-${(nowDate.getMonth() + 1)}`,
			});

			addHeader = nowDate.getFullYear();
			nowDate.setDate(-1, nowDate.getFullYear());
		}

		return dates;
	}

	getCategories() {
		const wanted = ['awards', 'editorials', 'caseTypes']; // this array decides the order
		const names = ['Awards', 'Editorial', 'Project types'];
		let categories = [];
		const constructed = [];

		categories = pick(this.props.categories, wanted);

		for (let i = 0; i < wanted.length; i++) {
			const catKey = wanted[i];
			const currentCategory = categories[catKey];

			if (!currentCategory) {
				continue;
			}

			constructed.push({
				label: names[i],
				name: wanted[i],
				value: currentCategory.map((item, i) => {
					return {
						id: item.id,
						label: item.title || item.name,
						name: catKey,
						value: (item.id || item.slug),
					};
				}),
			});
		}

		// console.log(constructed);
		return constructed;
	}

	fetchTimeline(filter) {
		if (typeof this.fetchDebounce !== 'function' && typeof this.props.timelineActions.fetchTimeline === 'function') {
			// debounce fetching of timeline, so it doesn't happen on every button toggle in the filter

			this.fetchDebounce = debounce(this.props.timelineActions.fetchTimeline, 1000);
		}

		if (typeof this.fetchDebounce === 'function') {
			this.fetchDebounce(filter);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/header/headerFilter/headerFilter.js
 **/